// SearchBarAnimator.jsx
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './SearchBarAnimator.css'; // Ensure this CSS file includes your animation styles

const SearchBarAnimator = ({ isVisible, animation, brandTheme, children }) => {
    const MaxWidthForMobile = 600;
    const wrapperRef = useRef(null);
    const isMobile = window.innerWidth <= MaxWidthForMobile;

    useEffect(() => {
        const searchBarElement = wrapperRef.current;
        if (searchBarElement) {
            if (isVisible) {
                // Trigger entry animation, wait 10ms to ensure the element is in the DOM
                const timeoutId = setTimeout(() => {
                    searchBarElement.classList.add('visible');
                    searchBarElement.style.width = brandTheme?.searchBar?.width || '400px';
                }, 10);

                if (brandTheme?.searchBar?.injectedContainer && wrapperRef.current) {
                    if (isMobile && brandTheme?.searchBar?.injectedContainer?.mobile) {
                        Object.assign(wrapperRef.current.style, brandTheme?.searchBar?.injectedContainer?.mobile);
                    }
                    else if (!isMobile && brandTheme?.searchBar?.injectedContainer?.desktop) {
                        Object.assign(wrapperRef.current.style, brandTheme?.searchBar?.injectedContainer?.desktop);
                    }
                }

                return () => clearTimeout(timeoutId);
            }
            else {
                // Trigger exit animation
                searchBarElement.classList.remove('visible');
                searchBarElement.style.width = '';
            }
        }
    }, [isVisible, brandTheme]);

    return <div className={`searchBarWrapper ${animation}`} ref={wrapperRef}>
        {children}
    </div>
};

SearchBarAnimator.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    animation: PropTypes.string.isRequired,
    brandTheme: PropTypes.shape({
        searchBarWidth: PropTypes.string,
    }),
    children: PropTypes.node.isRequired,
};

SearchBarAnimator.defaultProps = {
    brandTheme: {
        searchBarWidth: '400px',
    },
};

export default SearchBarAnimator;
